import { combineReducers } from 'redux'

import modalReducer from './modalReducer'
import authReducer from './authReducer'
import registerReducer from './registerReducer'
import recoverReducer from './recoverReducer'
import creditoReducer from './creditoReducer'
import pagoReducer from './pagoReducer'
import campaniaReducer from './campaniaReducer'
import cuentaReducer from './cuentaReducer'
import transactionalReducer from './transactionalReducer'
import transferenciaReducer from './transferenciaReducer'
import sessionReducer from './sessionReducer'

const rootReducer = combineReducers({
  modals: modalReducer,
  auth: authReducer,
  registerUser: registerReducer,
  recoverUser: recoverReducer,
  creditoReducer: creditoReducer,
  pagoReducer: pagoReducer,
  campaniaReducer: campaniaReducer,
  cuentaReducer: cuentaReducer,
  transactionalReducer: transactionalReducer,
  transferenciaReducer: transferenciaReducer,
  sessionReducer: sessionReducer
})

export default rootReducer
